<script>
	import { onMount, onDestroy } from 'svelte';

	import { auth, unJoin } from './services/firebase-service';

	import cloudinary from './services/cloudinary';

	import bgPhoto from './stores/bg-photo.js';

	import Welcome from './welcome.svelte';
	import Join from './join.svelte';
	import Lobby from './lobby.svelte';
	import Game from './game.svelte';

	import g from './stores/game';

	import { STATUSES, TEAMS, ACTIONS } from './utils/constants';

	g.setMnemonicOrGameIDFromURL();

	let authID;
	try {
		authID = localStorage.getItem('playerName');
	}
	catch(e) {}
	authID = authID || null;

	$: g.setAuthID(authID);

	// listen to auth and sign in anonymously
	const unAuthStateChange = auth.onAuthStateChanged(userData => {
		if (!userData) {
			auth.signInAnonymously();
			return;
		}

		console.log('firebase userData.uid:', userData.uid);

		if (userData.uid !== authID) {
			authID = userData.uid;
			localStorage.setItem('authID', authID)
		}
	});

	$: pageTitle = $g.mnemonic ? `Careful Clues - ${$g.mnemonic}` : 'Careful Clues Online Matchmaking';

	let innerWidth;

	function onPopState() {
		g.setMnemonicOrGameIDFromURL();
	}

	function onBeforeUnload(e) {
		unJoin({
			authID,
			gameID: $g.gameID,
			game: $g.game
		});
		return undefined;
	}
</script>

<svelte:head>
	<title>{pageTitle}</title>
</svelte:head>

<svelte:window on:beforeunload={onBeforeUnload} on:popstate={onPopState} bind:innerWidth />

<div
	class="hero-image"
	style="background: #{$bgPhoto.bgColorHex};">
	<div
		class="img"
		style="background-image: url('{cloudinary($bgPhoto, innerWidth, true).url}');"
	></div>
</div>

{#if authID}
	{#if $g.mnemonic === ''}
		<Welcome {authID} />
	{:else if $g.game && $g.playersInput}
		{#if !$g.authPlayerInput && $g.game.status < STATUSES.starting}
			<Join {authID} gameID={$g.gameID} game={$g.game} />
		{:else if $g.game.status < STATUSES.started}
			<Lobby {authID} gameID={$g.gameID} game={$g.game} gameRef={$g.gameRef} playersInput={$g.playersInput} authPlayerInput={$g.authPlayerInput} />
		{:else if $g.game.status >= STATUSES.started}
			<Game {authID} gameID={$g.gameID} game={$g.game} gameRef={$g.gameRef} playersInput={$g.playersInput} authPlayerInput={$g.authPlayerInput} />
		{/if}
	{:else}
		<!-- sometimes we are here (blank screen) for a few moments while things load -->
	{/if}
{/if}

<style lang="less">
	.hero-image {
		position: absolute;
		display: flex;
		top: 0; left: 0;
		width: 100vw; height: 100vh;
		align-items: flex-start;
		overflow: hidden;

		.img {
			display: block;
			min-width: 100vw;
			min-height: 100vh;
			margin: 0;
			padding: 0;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			background-origin: border-box;
			transition: opacity 1s;
		}
	}
</style>
